import { useRef, useState } from 'react';
import { Alert, Box, Button, Paper, Typography } from '@mui/material';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { links } from '../../platform/links';
import { runtime } from '../../platform/runtime';
import { resourceSections } from '../../content/resourceSections';

export default function ResourceCard({ article, heading = 'h3' }) {
    const [error, setError] = useState(false);
    const [opening, setOpening] = useState(false);
    const [failedImage, setFailedImage] = useState(null);
    const pending = useRef(false);
    const open = async event => {
        if (!runtime.isNative()) return; // Keep normal browser/new-tab link behavior.
        event.preventDefault();
        if (pending.current) return;
        pending.current = true;
        setOpening(true);
        setError(false);
        try { await links.openExternal(article.url); }
        catch { setError(true); }
        finally { pending.current = false; setOpening(false); }
    };
    return <Paper component="article" variant="outlined" sx={{ p: { xs: 2, sm: 3 }, borderRadius: 3, height: '100%', boxSizing: 'border-box', display: 'flex', flexDirection: 'column', minWidth: 0 }}>
        {article.image?.url && failedImage !== article.image.url && <Box component="img"
            src={article.image.url} alt={article.image.alt || ''} loading="lazy" decoding="async" referrerPolicy="no-referrer"
            onError={() => setFailedImage(article.image.url)}
            sx={{ display: 'block', width: '100%', aspectRatio: '16 / 9', maxHeight: 240, objectFit: 'cover', borderRadius: 2, mb: 2, bgcolor: 'action.hover' }} />}
        <Typography variant="overline" color="text.secondary" sx={{ lineHeight: 1.6 }}>CDC · {resourceSections.find(section => section.id === article.category).title}</Typography>
        <Typography component={heading} variant="h6" sx={{ fontWeight: 700, mt: 1, overflowWrap: 'anywhere' }}>{article.title}</Typography>
        <Typography sx={{ mt: 1, mb: 2 }}>{article.description}</Typography>
        <Box sx={{ mt: 'auto' }}>
            <Button component="a" href={article.url} target="_blank" rel="noopener noreferrer" onClick={open}
                aria-label={`Read on CDC: ${article.title}`} aria-disabled={opening || undefined}
                endIcon={<OpenInNewIcon />} sx={{ minHeight: 48, textAlign: 'left' }}>
                {opening ? 'Opening…' : 'Read on CDC'}
            </Button>
            {error && <Alert severity="error" sx={{ mt: 1 }}>Unable to open this article. Check your connection and try again.</Alert>}
        </Box>
    </Paper>;
}
